<div class="login-container">
  <!-- Left Side - Login Form -->
  <div class="login-form-side">
    <a (click)="goBack($event)" class="go-back-link">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      Go Back
    </a>
    <div class="login-form-wrapper">
      <!-- Logo -->
      <!-- <h1 class="page-title">Login</h1> -->
      <div class="login-logo">
        <div class="logo-icon">
          <img class="image" src="assets/images/Logo.png" alt="Logo">
        </div>
        <div class="logo-text">
          <div class="logo-company">RealTimeTrac</div>
          <div class="logo-tagline">Delivery Management System</div>
        </div>
      </div>

      <!-- Login Header -->
      <div class="login-header">
        <div
          style="font-size: 14px; font-weight: 600; color: var(--primary-green); text-transform: uppercase; letter-spacing: 1px; margin-bottom: 32px;">
          Your customers' time valued
        </div>
      </div>

      <!-- Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form" id="loginForm" novalidate>
        <app-form-input [form]="loginForm" controlName="organization_name" label="Organization Name"
          placeholder="Enter your organization name" [submitted]="submitted">
        </app-form-input>

        <app-form-input [form]="loginForm" controlName="email" label="Email Address" type="email"
          placeholder="you@example.com" [submitted]="submitted" [options]="rememberedEmails" [readonly]="true">
        </app-form-input>
        <app-form-input [form]="loginForm" controlName="password" label="Password" type="password"
          placeholder="Enter your password" [submitted]="submitted">
        </app-form-input>

        <div class="form-options">
          <div class="remember-me">
            <a class="forgot-password" [class.disabled-link]="disabledloginOtp"
              (click)="!disabledloginOtp && loginwithotp()">Login with OTP</a>
          </div>
          <a class="forgot-password" (click)="forgotpassword()">Forgot password ?</a>
        </div>
        <!-- Login Button -->
        <button type="submit" class="login-button" [disabled]="isSubmitting">
          <ng-container *ngIf="!isSubmitting; else loading">
            Login
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </ng-container>

          <ng-template #loading>
            <i class="fa fa-spinner fa-spin"></i>
            <span>Logging in...</span>
          </ng-template>
        </button>

        <!-- Terms -->
        <p class="terms-text">
          By signing in, you agree to our <a href="http://rtt-privacy-policy.s3-website.ap-south-1.amazonaws.com/"
            target="_blank">Terms of Service</a> and <a
            href="http://rtt-privacy-policy.s3-website.ap-south-1.amazonaws.com/" target="_blank">Privacy Policy</a>.
        </p>
      </form>
    </div>
  </div>

  <!-- Right Side - Illustration -->
  <!-- Right Side - Illustration -->
  <div class="illustration-side">
    <div class="slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeaveWrapper()">

      <!-- Tagline -->
      <h2 class="slider-tagline">
        Schedule. <span class="highlight-green">TRAC</span>. Deliver on <span class="highlight-yellow">Time</span>
      </h2>

      <!-- Slider Wrapper -->
      <div class="slider-wrapper" #sliderWrapper (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)"
        (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp($event)"
        (mouseleave)="onMouseLeave()">

        <!-- Previous Arrow -->
        <button class="slider-arrow prev" (click)="prevSlide()" aria-label="Previous slide">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <!-- Next Arrow -->
        <button class="slider-arrow next" (click)="nextSlide()" aria-label="Next slide">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <!-- Slides -->
        <div class="slide" *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': currentSlide === i }">
          <div class="slide-image">
            <img [src]="slide.image" [alt]="slide.title">
          </div>
          <div class="slide-content">
            <h3 class="slide-title">{{ slide.title }}</h3>
            <p class="slide-description">{{ slide.description }}</p>
          </div>
        </div>
      </div>

      <!-- Progress Bar -->
      <div class="slider-progress">
        <div class="slider-progress-bar" [style.width.%]="((currentSlide + 1) / slides.length) * 100"></div>
      </div>

      <!-- Navigation Dots -->
      <div class="slider-nav">
        <div class="slider-dot" *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': currentSlide === i }"
          (click)="showSlide(i)">
        </div>
      </div>

    </div>
  </div>

</div>

<!-- Change Password Modal - Sidebar Style -->
<div class="modal-backdrop" (click)="closeChangePasswordModal()" *ngIf="showChangePasswordModal" #changePasswordBackdrop
  [class.show]="showChangePasswordModal">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h3>Change Password</h3>
      <button class="close-btn" (click)="closeChangePasswordModal()">✕</button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <form [formGroup]="newPassword">
        <div class="form-group" style="margin-bottom: 16px;">
          <label
            style="font-size: 13px; font-weight: 500; color: var(--text-primary); display: block; margin-bottom: 8px;">New
            Password <span class="required-indicator">*</span></label>
          <div style="position: relative;">
            <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
              placeholder="Enter new password" class="form-input" />
            <button type="button" class="toggle-password" (click)="toggleNewPassword()">
              <!-- Eye Icon (Visible) -->
              <svg *ngIf="!showNewPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <!-- Eye Slash Icon (Hidden) -->
              <svg *ngIf="showNewPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </button>
          </div>
          <div *ngIf="isSubmittedes && n['newPassword'].errors"
            style="color: #ef4444; font-size: 12px; margin-top: 4px;">
            <div *ngIf="n['newPassword'].errors['required']">New Password is required</div>
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 16px;">
          <label
            style="font-size: 13px; font-weight: 500; color: var(--text-primary); display: block; margin-bottom: 8px;">Confirm
            Password <span class="required-indicator">*</span></label>
          <div style="position: relative;">
            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
              placeholder="Confirm your password" class="form-input" />
            <button type="button" class="toggle-password" (click)="toggleConfirmPassword()">
              <!-- Eye Icon (Visible) -->
              <svg *ngIf="!showConfirmPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <!-- Eye Slash Icon (Hidden) -->
              <svg *ngIf="showConfirmPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </button>
          </div>
          <div *ngIf="isSubmittedes && n['confirmPassword'].errors"
            style="color: #ef4444; font-size: 12px; margin-top: 4px;">
            <div *ngIf="n['confirmPassword'].errors['required']">Confirm Password is required</div>
          </div>
        </div>

        <div *ngIf="isSubmittedes && newPassword.hasError('passwordMismatch')"
          style="color: #ef4444; font-size: 12px; margin-bottom: 16px;">
          Passwords do not match
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn cancel" (click)="closeChangePasswordModal()">Cancel</button>
      <button class="btn success" (click)="onChangePasswordConfirm()">Change Password</button>
    </div>
  </div>
</div>

<!-- Enter City Modal - Sidebar Style -->
<div class="modal-backdrop" (click)="closeCityModal()" *ngIf="showCityModal" #cityBackdrop [class.show]="showCityModal">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h3>Enter The City</h3>
      <button class="close-btn" (click)="closeCityModal()">✕</button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- <p>Please enter your city to continue</p> -->
      <form style="margin-top: 16px;">
        <div class="form-group">
          <label
            style="font-size: 13px; font-weight: 500; color: var(--text-primary); display: block; margin-bottom: 8px;">Enter
            City <span class="required-indicator">*</span></label>
          <input type="text" [(ngModel)]="city" name="city" placeholder="Enter your city"
            (ngModelChange)="onCityChange()" class="form-input" />
          <div *ngIf="showError" style="color: #ef4444; font-size: 12px; margin-top: 4px;">
            City is required
          </div>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn cancel" (click)="closeCityModal()">Cancel</button>
      <button class="btn success" (click)="onCityConfirm()">Confirm</button>
    </div>
  </div>
</div>